import { last } from '@antv/util';
import catTicks from './cat';
/**
 * è®¡ç®æ¶é´åç±»ç ticks, ä¿å¤´ï¼ä¿å°¾
 * @param cfg åº¦éçéç½®é¡¹
 * @returns è®¡ç®åç ticks
 */
export default function calculateTimeCatTicks(cfg) {
    var ticks = catTicks(cfg);
    var lastValue = last(cfg.values);
    if (lastValue !== last(ticks)) {
        ticks.push(lastValue);
    }
    return ticks;
}
//# sourceMappingURL=time-cat.js.map